"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
const action_1 = require("./action");
const state_1 = require("./state");
function reducer(state, action) {
    switch (action.type) {
        case action_1.ActionType.OpenModal:
            return {
                modal: action.payload,
            };
        case action_1.ActionType.CloseModal:
            return {
                modal: state_1.NOOPModal,
            };
        default:
            return state;
    }
}
exports.reducer = reducer;
;
